module.exports = __webpack_public_path__ + "img/40_38_034_160.b328995d.jpg";